import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { HierarchyTree, Link, LinkVariant } from '@as/cotopaxi';
import { useAemConfig } from '@as-react/common-components';
import { isEqual, getHomepageUrl } from '@as-react/common-utils';
import { useCallback } from 'react';
import { useCategoryHierarchyTree } from '../../../hooks/useCategoryHierarchyTree';
import { concatUrls } from '../../../util/UrlUtil';
import { CategoryHierarchyTreeMobileHelper } from './CategoryHierarchyTreeMobileHelper';
const CATEGORY_HIERARCHY_TREE_BANNER_ID = 'product-lister-category-tree';
export const CategoryHierarchyTree = () => {
    const { isInAuthorMode, root, rootWithLanguageSuffix, lang } = useAemConfig();
    const { categoryIds, categoryHierarchyTree } = useCategoryHierarchyTree();
    const getUrl = (categoryPath) => concatUrls(isInAuthorMode ? rootWithLanguageSuffix : root, getHomepageUrl(categoryPath));
    const renderHierarchyTreeItem = useCallback((item, _, parents) => {
        var _a;
        const translatedProperty = (_a = item.categoryTranslatedProperties) === null || _a === void 0 ? void 0 : _a[lang.toLocaleUpperCase()];
        if (isEqual(categoryIds, [...parents.map(parent => parent.categoryId), item.categoryId])) {
            return (_jsx(Link, { variant: LinkVariant.SUBTLE, emphasize: true, href: getUrl(translatedProperty.link), children: translatedProperty.description }));
        }
        return (_jsx(Link, { variant: LinkVariant.SUBTLE, href: getUrl(translatedProperty.link), children: translatedProperty.description }));
    }, [categoryHierarchyTree, categoryIds]);
    if (!categoryHierarchyTree) {
        return null;
    }
    return (_jsxs(_Fragment, { children: [_jsx(CategoryHierarchyTreeMobileHelper, { categoryIds: categoryIds, hierarchyTree: categoryHierarchyTree }), _jsx("div", { "data-analytics-bannerid": CATEGORY_HIERARCHY_TREE_BANNER_ID, children: _jsx(HierarchyTree, { hierarchyTree: categoryHierarchyTree, renderItem: renderHierarchyTreeItem }) })] }));
};
